import React, {useEffect, useState} from 'react';
import {Button, Message, MessageContent, MessageHeader, Modal} from 'semantic-ui-react';
import PROCESSING from "components/cmp_processing/cmp_processing";
import ICON from 'components/cmp_icon/cmp_icon';

import './cmp_confirmation.css';
import MESSAGE from "components/cmp_message/cmp_message";

export default function CMP_CONFIRMATION({ button_onClick, button_text, confirmation_state, confirmation_subtitle, confirmation_title, onClose, onOpen, processing_status, text }) {

    //  variable declarations ------------------------------------------------------------------------------------------

    const [var_processing, set_processing] = useState('inactive');
    const [var_can_process, set_can_process] = useState(true);



    //  event listeners ------------------------------------------------------------------------------------------------



    //  async functions ------------------------------------------------------------------------------------------------



    //  API calls ------------------------------------------------------------------------------------------------------



    //  event functions ------------------------------------------------------------------------------------------------

    function onClick_primary() {

    }

    function onClick_cancel() {
        onClose();
    }



    // RENDER APP ======================================================================================================

    return (
        <Modal
            dimmer={'inverted'}
            onClose={onClose}
            open={onOpen}
            closeOnEscape={true}
            closeOnDimmerClick={true}
            id='cmp_confirmation'>

            <div className='modal__content'>

                <MESSAGE
                    header={confirmation_title}
                    text={confirmation_subtitle}
                    state={confirmation_state}
                />
                <p>{text}</p>
            </div>

            <PROCESSING state={processing_status}/>

            <div className='modal__footer'>
                <Button className={'primary ' + (confirmation_state)} onClick={button_onClick}>{button_text}</Button>
                <Button className='secondary' onClick={onClick_cancel}>Cancel</Button>
            </div>
        </Modal>
    );
}
